import { render } from "./paquetes.vue?vue&type=template&id=dab7580c"
import script from "./paquetes.vue?vue&type=script&lang=js"
export * from "./paquetes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__